<template>
  <v-container fluid class="hirek hirlista-oldal">
    <div :class="{ 'page-content': !isMobile }">
      <v-btn
        icon
        large
        color="primary"
        class="back-btn"
        @click="$goBackTo({ name: 'Fooldal' })"
      >
        <i class="fas fa-chevron-left"></i>
      </v-btn>
      <h2>Népszerű hírek</h2>
      <v-tabs
        show-arrows
        next-icon="fas fa-angle-right"
        prev-icon="fas fa-angle-left"
        v-model="tab"
        class="mt-2"
      >
        <v-tabs-slider color="primary"></v-tabs-slider>

        <v-tab
          v-for="alKategoria in getAlkategoriak"
          :key="alKategoria.Id"
          v-html="alKategoria.Nev"
        >
        </v-tab>
      </v-tabs>
      <v-tabs-items
        :touchless="true"
        :next-icon="false"
        :prev-icon="false"
        v-model="tab"
      >
        <v-tab-item
          v-for="alKategoria in getAlkategoriak"
          :key="alKategoria.Id"
        >
          <k-hir-lista :getHirek="GetHirek(alKategoria.Id)"></k-hir-lista>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../functions/AppFunctions';
import { hirService } from '../services/HirService';
import { AppStoreTypes } from '../store/modules/app';

export default {
  name: 'NepszeruHirek',
  data() {
    return {
      tab: null,
    };
  },
  mounted() {},
  created() {},
  methods: {
    GetHirek(alkategoriaId) {
      return utolsoHir => {
        return hirService.GetNepszeruHirek({
          kategoriaId: alkategoriaId,
          utolsoNepszerusegiIndexId: utolsoHir?.NepszerusegiIndex,
        });
      };
    },
  },
  computed: {
    ...mapGetters({ hirKategoriak: AppStoreTypes.hirKategoriak.getAll }),
    tabUpdate() {
      return [this.hirKategoriak.length, this.routeHirKategoriaId].join('_');
    },
    routeHirKategoriaId() {
      return this.$route.params.id;
    },
    getAlkategoriak() {
      return AppFunctions.GetAlkategoriakFromKategoriak(this.hirKategoriak);
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  watch: {
    tabUpdate: {
      handler(v) {
        let routeHirKategoriaId = this.routeHirKategoriaId;
        let idx = this.getAlkategoriak.findIndex(
          f => f.Id == routeHirKategoriaId
        );
        if (idx) {
          this.tab = idx;
        }
      },
      immediate: true,
    },
  },
  components: {},
};
</script>
